import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	standalone: false,
	selector: 'semantic-view',
	template: `
		<div class="semantic-view">
			<header class="semantic-header" [class.hide-on-small-devices]="hideOnMobile">
				<ng-content select="[header]"></ng-content>
			</header>

			<main class="semantic-main" [class.full-screen]="hideOnMobile">
				<ng-content></ng-content>
			</main>

			<footer class="semantic-footer" [class.hide-on-small-devices]="hideOnMobile">
				<ng-content select="[footer]"></ng-content>
			</footer>
		</div>
	`,
	styleUrls: ['../Css/Components/semantic-view.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SemanticViewComponent {
	@Input() hideOnMobile: boolean = false;
}
